import { Head, useForm } from "@inertiajs/react"
import { Container, Section } from "@radix-ui/themes"
import ClubForm, { ClubFormData } from "@/shared/admin/ClubForm"

interface Props {
  club: {
    id: number
    slug: string
    [key: string]: any
  }
  errors?: { [key: string]: string[] }
}

export default function EditClub({ club, errors }: Props) {
  const initialData: ClubFormData = {
    club: {
      name: club.name || "",
      slug: club.slug || "",
      description: club.description || "",
      history: club.history || "",
      instagram: club.instagram || "",
      threads: club.threads || "",
      facebook: club.facebook || "",
      website: club.website || "",
      locale: club.locale || "",
      galleries_enabled: club.galleries_enabled ?? false,
      blogs_enabled: club.blogs_enabled ?? false,
      // Falls back to the column default rather than 0, so a club created
      // before the column existed doesn't render as a zero-byte quota.
      storage_quota_bytes: club.storage_quota_bytes ?? 10 * 1024 ** 3,
      // "" rather than null: the field is a controlled input, and empty is what
      // "no house colour, fall through to the default" looks like in a form.
      gallery_accent: club.gallery_accent || "",
      gallery_accent_2: club.gallery_accent_2 || "",
    },
  }

  const { data, setData, patch, processing } = useForm(initialData)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    patch(`/clubs/${club.slug}`)
  }

  return (
    <div className="flex">
      <Head title={`Edit ${club.name}`} />
      <div className="grow">
        <Section>
          <Container size="4">
            <ClubForm
              data={data}
              setData={setData}
              onSubmit={handleSubmit}
              processing={processing}
              errors={errors}
              title={`Edit ${club.name}`}
              submitLabel="Update Club"
            />
          </Container>
        </Section>
      </div>
    </div>
  )
}
